import React, { useEffect } from "react";
import Axios from "../api/Axios";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { userData } from "../store/slices/UserInfo";
import { allowedRoles } from "../components/icons/ApplicationColor";
import { processIframes } from "../IframeHelper";
import { resetNotifications } from "../store/slices/notificationSlice";
import Spinner from "../components/Spinner";
const ImpersonateSwitchBack = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const history = useNavigate();
  const userInfo = useSelector((state) => state.user.data);
  const leftMenuNames = userInfo?.left_menu;
  useEffect(() => {
    dispatch(resetNotifications());
    handleLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const WrongPassword = () => {
    messageApi.open({
      type: "error",
      content: "Error Switching back the user. Please try later",
      duration: 7,
    });
  };

  const ImpersonateAuthUser = async () => {
    try {
      const res = await Axios.get("/auth-user/");
      dispatch(userData(res.data));
      const isAdmin = res.data.roles.some((app) =>
        allowedRoles.includes(app.key_name)
      );
      if (isAdmin) {
        localStorage.setItem("isAdmin", "true");
        //console.log("role set");
      } else {
        localStorage.removeItem("isAdmin");
      }
      if (res.data?.is_superadmin) {
        localStorage.setItem("superadmin", "is-super-admin");
        history("/admin-manager/clients");
      } else {
        localStorage.setItem("superadmin", "is-normal-user");
      }
    } catch (err) {
      WrongPassword();
      history("/logout");
    }
  };

  const ImpersonateApi = async () => {
    try {
      const res = await Axios.get(
        `/impersonatelogout/${localStorage.getItem("impersonateOriginalID")}/`
      );
      //console.log(res);
      localStorage.setItem("token", res.data.token);
      localStorage.removeItem("impersonateOriginalID");
      localStorage.removeItem("impersonateLoginID");
      ImpersonateAuthUser();
      //console.log(res);
    } catch (err) {
      WrongPassword();
      history("/logout");
    }
  };
  const handleLogout = async () => {
    try {
      await processIframes(leftMenuNames, dispatch);
      const impersonateOriginalID = localStorage.getItem(
        "impersonateOriginalID"
      );
      const impersonateCheck = localStorage.getItem("impersonateCheck");
      const impersonateLoginID = localStorage.getItem("impersonateLoginID");
      localStorage.removeItem("token");
      localStorage.clear();

      localStorage.setItem("impersonateOriginalID", impersonateOriginalID);
      localStorage.setItem("impersonateCheck", impersonateCheck);
      localStorage.setItem("impersonateLoginID", impersonateLoginID);

      ImpersonateApi();
    } catch (err) {
      WrongPassword();
      history("/logout");
    }
  };

  return (
    <div>
      {contextHolder}
      <Spinner />
    </div>
  );
};

export default ImpersonateSwitchBack;
